import { Injectable, signal, WritableSignal } from '@angular/core';
import { MovilityType, RegisterUserLocation } from '../interfaces/register-user.response';
import { initialTransportMeans } from '../shared/components/transport-means-field/config/constants';
import { FormGroup } from '@angular/forms';
import { RegisterUserForm } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class RegisterUserFormService {
  private _startDate: WritableSignal<Date> = signal(null);
  public startDate = this._startDate.asReadonly();
  
  private _endDate: WritableSignal<Date> = signal<Date>(null);
  public endDate = this._endDate.asReadonly();
  
  private _startTime: WritableSignal<string> = signal<string>(null);
  public startTime = this._startTime.asReadonly();
  
  private _endTime: WritableSignal<string> = signal<string>(null);
  public endTime = this._endTime.asReadonly();

  private _startLocation: WritableSignal<RegisterUserLocation> = signal<RegisterUserLocation>(null);
  public startLocation = this._startLocation.asReadonly();
  
  private _endLocation: WritableSignal<boolean> = signal(false);
  public endLocation = this._endLocation.asReadonly();
  
  private _movilityType: WritableSignal<MovilityType> = signal<MovilityType>(null);
  public movilityType = this._movilityType.asReadonly();
  
  private _tripTypeId: WritableSignal<number> = signal<number>(null);
  public tripTypeId = this._tripTypeId.asReadonly();

  private _interests: WritableSignal<number[]> = signal<number[]>([]);
  public interests = this._interests.asReadonly();
  
  private _transportMeans: WritableSignal<string[]> = 
    signal<string[]>([initialTransportMeans.value]);
  public transportMeans = this._transportMeans.asReadonly();
  
  private _maxDistanceWalking: WritableSignal<number> = signal(1000);
  public maxDistanceWalking = this._maxDistanceWalking.asReadonly();
  
  private _geoLocation: WritableSignal<boolean> = signal(false);
  public geoLocation = this._geoLocation.asReadonly();
  
  private _markAllFormFieldsAsTouched = signal<boolean>(false);
  public markAllFormFieldsAsTouched = this._markAllFormFieldsAsTouched.asReadonly();
  
  public setStartDate(date: Date): void {
    this._startDate.set(date);
  }
  
  public setEndDate(date: Date): void {
    this._endDate.set(date);
  }
  
  public setStartTime(time: string): void {
    this._startTime.set(time);
  }
  
  public setEndTime(time: string): void {
    this._endTime.set(time);
  }
  
  public setStartLocation(location: RegisterUserLocation): void {
    this._startLocation.set(location);
  }
  
  public setEndLocation(isDifferent: boolean): void {
    this._endLocation.set(isDifferent);
  }
  
  public setMovilityType(movilityType: MovilityType): void {
    this._movilityType.set(movilityType);
  }
  
  public setTripType(tripTypeId: number): void {
    this._tripTypeId.set(tripTypeId);
  }

  public setInterests(interests: number[]): void {
    this._interests.set(interests);
  }
  
  public setTransportMeans(transportMeans: string[]): void {
    this._transportMeans.set(transportMeans);
  }
  
  public setMaxDistanceWalking(distance: number): void {
    this._maxDistanceWalking.set(distance);
  }
  
  public setGeoLocation(useGeo: boolean): void {
    this._geoLocation.set(useGeo);
  }
  
  setMarkAllFormFieldsAsTouched(markAsTouched: boolean): void {
    this._markAllFormFieldsAsTouched.set(markAsTouched);
  }
  
  public resetForm(form: FormGroup<RegisterUserForm>): void {
    // Reset all signals to their initial values
    this._startDate.set(null);
    this._endDate.set(null);
    this._startTime.set(null);
    this._endTime.set(null);
    this._startLocation.set(null);
    this._endLocation.set(false);
    this._movilityType.set(null);
    this._tripTypeId.set(null);
    this._interests.set([]);
    this._transportMeans.set([initialTransportMeans.value]);
    this._maxDistanceWalking.set(1000);
    this._geoLocation.set(false);

    // Reset the form with the initial values
    form.reset({
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      startLocationAddress: null,
      startLocationLat: null,
      startLocationLng: null,
      endLocation: false,
      movilityType: null,
      tripType: null,
      interestIdList: [],
      transportMeans: [initialTransportMeans.value],
      maxDistanceWalking: 1000,
      geolocation: false,
    });
  }
}
